import { MedTransGoConstants } from './constants';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest } from '@/types/request';
import fileDownload from 'js-file-download';

/**
 * @author <Aniket.P>
 * @description Resource utils
 * @copyright Supra International, inc
 */
export class ResourceUtils {


    public static async getResourceUrl(baseUrl: string, resourceId: string): Promise<string> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: baseUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}/${resourceId}`,
        };
        const response = await iHttpService.get<any>(apiRequest);
        return response.data;
    }

    public static downloadFileIntoDevice(data: any, filename: string) {
        fileDownload(data, filename);
    }

}
